import { ComponentProps } from "react";
import * as S from "./styles";
interface IInputRadioProps extends ComponentProps<"input"> {
  label: string;
}

export const InputRadio = ({ label, ...rest }: IInputRadioProps) => {
  return (
    <S.InputRadioContainerStyle>
      <input {...rest} type="radio" />
      <span>{label}</span>
    </S.InputRadioContainerStyle>
  );
};
